import cn from 'classnames';
import { Tooltip } from '@fashionnovateam/nova-ui-toolkit';

interface DiffHighlightProps {
  newValue?: string | null;
  oldValue?: string | null;
  rightAlign?: boolean;
  variant?: 'primary' | 'secondary';
}

export function DiffHighlight({
  newValue,
  oldValue,
  rightAlign,
  variant = 'primary',
}: DiffHighlightProps) {
  const newValueBgClass =
    variant === 'primary'
      ? 'text-warning-900 bg-warning-100'
      : 'text-base-primary';

  const oldValueStrikethroughClass =
    variant === 'primary'
      ? 'text-warning-900'
      : 'text-base-disabled opacity-55';

  return (
    <div className="w-full">
      <Tooltip
        content={
          <div className="flex gap-2">
            <span className="text-primary-100">{newValue}</span>
            <span className="text-secondary-100 text-opacity-75 line-through">
              {oldValue}
            </span>
          </div>
        }
        arrow
        position="top"
        childrenContainerAttributes={{
          className: 'w-full',
        }}
      >
        <div
          className={cn('flex gap-2 max-w-full', rightAlign && 'justify-end')}
        >
          {newValue ? (
            <span
              className={`whitespace-nowrap font-semibold ${newValueBgClass}`}
            >
              {newValue}{' '}
            </span>
          ) : null}
          {oldValue ? (
            <span
              className={`overflow-hidden text-ellipsis whitespace-nowrap line-through ${oldValueStrikethroughClass}`}
            >
              {oldValue}
            </span>
          ) : null}
        </div>
      </Tooltip>
    </div>
  );
}
